<template>
<el-dialog title="" append-to-body :modal="false" :visible.sync="showRecover" width="90%" :close-on-click-modal="false" 
  custom-class="dialogBox" :before-close="dialogBeforeClose">
  <div class="loginBox">
    <div>
      <div class="titleText">Create an Account</div>
      <el-form ref="form" :model="form" label-width="0" :rules="rules">
          <el-form-item label="" prop="name">
            <el-input class="inputBox" v-model="form.name" placeholder="Full name/Company name"></el-input>
          </el-form-item>
          <el-form-item label="" prop="account">
            <el-input class="inputBox" v-model="form.account" placeholder="Enter Your E-mail Address"></el-input>
          </el-form-item>
          <el-form-item label="" >
              <el-input class="inputBox" v-model="pwd1" placeholder="Password" type="password" ></el-input>
          </el-form-item>
          <el-form-item label="" >
              <el-input class="inputBox" v-model="pwd2" placeholder="Confirm Password " type="password" ></el-input>
          </el-form-item>
          <div class="pasEro" v-show="showError">Passwords do not match.</div>
          
      </el-form>
      <div @click="goLogin" class="goLoginText">Go and log in</div>
      <div class="loginBtn" @click="save">Submit</div>
    </div>
  </div>
</el-dialog>

</template>

<script>
import { sm2 } from 'sm-crypto';
import { VITE_SM_PUBLIC_KEY } from '@/assets/js/conSysUrl'
import { addUser } from '@/api/user'
import { debounce } from 'lodash';
export default {
  props:['showLogin'],
  data() {
    return {
      showRecover: false,
      showError: false,
      form: {
        name: '',
        account: '',
        pwd: '',
      },
      rules: {
        name: [ { required: true, message: 'Please enter your name', trigger: 'blur' }, ],
        account: [ { required: true, message: 'Please enter email address', trigger: 'blur' }, ],
      },
      pwd1: '',
      pwd2: '',
    }
  },
  methods: {
    dialogBeforeClose() {
      this.pwd1 = '',
      this.pwd2 = '',
      this.$refs.form.resetFields()
      this.$refs.form.clearValidate()
      this.showError = false,
      this.showRecover = false
    },
    show() {
      this.showRecover = true
    },
    goLogin() {
      this.dialogBeforeClose()
      this.$emit('showLogin')
    },
    save:debounce(async function() {
      if (this.pwd1.length < 6 || this.pwd2.length < 6) { 
        this.$message.error('Password must be at least 6 characters')
        return
      }
      if (this.pwd1 != this.pwd2) {
        this.showError = true
        this.$message.error('Password does not match')
        return
      }
      this.showError = false
      const publicKey = VITE_SM_PUBLIC_KEY;

      this.form.pwd =sm2.doEncrypt(this.pwd1, publicKey, 1),
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const {status} = await addUser(this.form)
            if (status) {
              this.$message.success('User created successfully')
              this.goLogin()
            }
          } catch (error) {
            // this.$message.success(error)
          }

        } else {
          return false
        }
      })
    },300),
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .dialogBox{
    min-width: 350px;
    max-width: 626px;
  }
  .el-dialog__body{
    padding: 10px;
  }
  .el-input__inner{
    border-radius: 10px;
    background: #f4f4f4;
  }
  .el-dialog__headerbtn{
    font-size: 30px;
    font-weight: 600;
  }
}

.loginBox{
  width: 100%;
  >div{
    margin: 0 auto;
    width: 300px;
    .titleText{
      color: #181818;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 20px;
    }
    .pasEro{
      color: #ff0000;
      font-size: 12px;
      text-align: center;
      margin-bottom: 10px;

    }
    .codeBox{
      display: flex;
      align-items: center;
      // margin-bottom: 20px;
    }
    .inputBox{
      // margin: 10px 0;
    }
    .forgotText{
      margin: 10px 0;
      font-size: 12px;
      color: #cbac92;
      text-align: end;
    }
    .goLoginText{
      cursor: pointer;
      text-align: center;
      margin: 10px 0;
      color: #cbac92;
    }
    .loginBtn{
      user-select: none;
      margin: 0 auto 30px;
      text-align: center;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      background-color: #000;
      font-weight: 600;
      color: #fff;
    }
    .loginBtn:hover{
     background: #cbac92;
     color: #000;
    }
    .createBox{
      margin: 30px 0;
      text-align: center;
      font-size: 14px;
      >div:nth-child(2){
        cursor: pointer;
        color: #cbac92;
      }
    }
  }


}



</style>